import { render } from "./TransferVirtualAgent.vue?vue&type=template&id=1a992234&ts=true"
import script from "./TransferVirtualAgent.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransferVirtualAgent.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/connect-flow/components/flow/nodes/TransferVirtualAgent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a992234"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a992234', __exports__)) {
    api.reload('1a992234', __exports__)
  }
  
  module.hot.accept("./TransferVirtualAgent.vue?vue&type=template&id=1a992234&ts=true", () => {
    api.rerender('1a992234', render)
  })

}


export default __exports__